import React, { useContext, useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  IconButton, Stack
} from "@mui/material";
import { Close, Save } from "@mui/icons-material";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import { Loading } from "../EMA/EMAPageSeparation";
import { submitPLRData, submitProcessedPLRData } from "../../api/AdminPage";
import Styles from "./styles/Review.styles";
import Actions from "../../store/actions";
import Store from "../../store";
import { indexSorting, labelSorting } from "../EMA/EMALabelCreation";
import { LabelMapper } from "./NonPLRPage";
import Switch from "@mui/material/Switch";

const nonEditableLabel = [
  "appl_num",
  "curator_email",
  "curator_name",
  "isPLR",
  "key",
  "label_path",
  "pdf_url",
  "status",
  "submission_num",
  "submission_type"
];
const labelOrder = [
  "indications_and_usage",
  "dosage_and_administration",
  "dosage_forms_and_strengths",
  "contraindications",
  "warnings_and_precautions",
  "adverse_reactions",
  "drug_interactions",
  "use_in_specific_populations",
  "drug_abuse_and_dependence",
  "overdosage",
  "description",
  "clinical_pharmacology",
  "non_clinical_toxicology",
  "clinical_studies",
  "references",
  "how_supplied_storage_and_handling",
  "patient_counseling_information"
];

// eslint-disable-next-line react/prop-types
const PLRPage = ({ edit, handleSwitch, res, page,autoSort,setAutoSort }) => {
  const history = useHistory();
  const classes = Styles();

  const { dispatch } = useContext(Store);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setSubmitting] = useState(false);
  const [error, setError] = useState({});
  const [openSubmitConfirmation, setOpenSubmitConfirmation] = useState(false);

  const [labelData, setLabelData] = useState(null);
  const [labelInitialData, setLabelInitialData] = useState(null);
  const handleSubmit = async () => {
    setSubmitting(true);
    setOpenSubmitConfirmation(false);
    const user = await Auth.currentUserInfo();
    const payload = {
      key: labelData.key,
      appl_num: labelData.key.split("-")[0],
      // eslint-disable-next-line react/prop-types
      submission_num: res.submission_num ?? "",
      submission_type: labelData.submission_type ?? "",
      indications_and_usage: labelData.indications_and_usage ?? "",
      dosage_and_administration: labelData.dosage_and_administration ?? "",
      dosage_forms_and_strengths: labelData.dosage_forms_and_strengths ?? "",
      contraindications: labelData.contraindications ?? "",
      warnings_and_precautions: labelData.warnings_and_precautions ?? "",
      adverse_reactions: labelData.adverse_reactions ?? "",
      drug_abuse_and_dependence: labelData.drug_abuse_and_dependence ?? "",
      drug_interactions: labelData.drug_interactions ?? "",
      use_in_specific_populations: labelData.use_in_specific_populations ?? "",
      overdosage: labelData.overdosage ?? "",
      description: labelData.description ?? "",
      clinical_pharmacology: labelData.clinical_pharmacology ?? "",
      non_clinical_toxicology: labelData.non_clinical_toxicology ?? "",
      clinical_studies: labelData.clinical_studies ?? "",
      references: labelData.references ?? "",
      how_supplied_storage_and_handling: labelData.how_supplied_storage_and_handling ?? "",
      patient_counseling_information: labelData.patient_counseling_information ?? "",
      label_path: labelData.label_path ?? "",
      status: labelData.status ?? "",
      curator_email: user.attributes.email,
      curator_name: user.attributes["custom:user"]
    };
    if (page === "processed") {
      await submitProcessedPLRData(payload);
      history.push("/fda/label/section");
    } else {
      await submitPLRData(payload);
      history.push("/reviews");
    }
    await dispatch({
      type: Actions.SET_ALERT,
      value: { status: true, message: "Document label mapped successfully" }
    });
  };
  const handleSubmitChanges = () => {
    setOpenSubmitConfirmation(true);
  };

  const handleSubmitCheck = () => {
    let valueCount = 0;
    let emptyValueCount = 0;
    Object.entries(labelData ?? {}).forEach(([key, value]) => {
      valueCount += 1;
      if (!nonEditableLabel.includes(key)) {
        if (!value) {
          emptyValueCount += 1;
        }
      }
    });
    return (
      valueCount === emptyValueCount ||
      JSON.stringify(labelInitialData) === JSON.stringify(labelData) ||
      Object.keys(error).length !== 0
    );
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (res === undefined) {
          throw Error("No response");
        }
        console.log(res);
        // eslint-disable-next-line react/prop-types
        if (res) {
          setLoading(false);
          const localRes = { ...res };
          delete localRes.submission_num;
          const payload = {
            key: localRes.key,
            appl_num: localRes.key.split("-")[0],
            submission_type: localRes.submission_type ?? "",
            indications_and_usage: localRes.indications_and_usage ?? "",
            dosage_and_administration: localRes.dosage_and_administration ?? "",
            dosage_forms_and_strengths: localRes.dosage_forms_and_strengths ?? "",
            contraindications: localRes.contraindications ?? "",
            warnings_and_precautions: localRes.warnings_and_precautions ?? "",
            adverse_reactions: localRes.adverse_reactions ?? "",
            drug_abuse_and_dependence: localRes.drug_abuse_and_dependence ?? "",
            drug_interactions: localRes.drug_interactions ?? "",
            use_in_specific_populations: localRes.use_in_specific_populations ?? "",
            overdosage: localRes.overdosage ?? "",
            description: localRes.description ?? "",
            clinical_pharmacology: localRes.clinical_pharmacology ?? "",
            non_clinical_toxicology: localRes.non_clinical_toxicology ?? "",
            clinical_studies: localRes.clinical_studies ?? "",
            references: localRes.references ?? "",
            how_supplied_storage_and_handling: localRes.how_supplied_storage_and_handling ?? "",
            patient_counseling_information: localRes.patient_counseling_information ?? "",
            label_path: localRes.label_path ?? "",
            status: localRes.status ?? ""
          };
          // eslint-disable-next-line react/prop-types
          setLabelData({ ...payload });
          // eslint-disable-next-line react/prop-types
          setLabelInitialData({ ...payload });
        } else {
          setLoading(false);
          throw Error("No data");
        }
      } catch (err) {
        console.log(err);
        await dispatch({
          type: Actions.SET_ALERT,
          value: { status: true, message: "Enter valid information" }
        });
        // history.push('/admin/reviews');
      }
    };
    fetchData();
  }, [res]);

  return (
    <Grid item xs={12} lg={6} className={classes.grid}>
      {edit && (
        <>
          <Box display="flex" padding={1} flexDirection="row" justifyContent="space-between">
            <div>
              <Button
                className={classes.button}
                disabled={loading}
                onClick={() => history.goBack()}
                variant="contained">
                Go back
              </Button>
            </div>
            <div>
              <Button className={classes.button} onClick={handleSwitch} variant="contained">
                Cancel
              </Button>
            </div>
            <div>
              <Button
                className={classes.button}
                disabled={loading || handleSubmitCheck()}
                onClick={handleSubmitChanges}
                variant="contained">
                Submit
              </Button>
            </div>

          </Box>

          <Stack direction={'row'} width={'100%'} justifyContent={'center'}>
            <FormControlLabel
              sx={{
                '& .MuiFormControlLabel-label': {
                  color: 'white'
                },
                '& .MuiSwitch-track': {
                  backgroundColor: 'white'
                }
              }}
              control={<Switch  />} checked={autoSort} onChange={(event) => {
              setAutoSort(event.target.checked);
            }} label="Auto sorting" />

          </Stack>
        </>
      )}

      {loading || isSubmitting ? (
        <Loading dataLoading={loading} dataSubmitting={isSubmitting} />
      ) : (
        labelData && (
          <Box
            minHeight="50vh"
            maxHeight="75vh"
            className={`${classes.pdfContainer} ${classes.formSection}`}>
            {
              !autoSort ?
                Object.entries(labelData).map(([key, value]) => (
                  <LabelMapper
                    disableDuplicateCheck
                    key={key}
                    disabled={!edit}
                    label={key}
                    index={value}
                    setLabelData={setLabelData}
                    labelData={labelData}
                    setError={setError}
                    error={error}
                  />
                )) :
                Object.entries(labelData)
                  .sort(labelSorting(labelOrder, true))
                  .sort(indexSorting(true))
                  .map(([key, value]) => (
                    <LabelMapper
                      disableDuplicateCheck
                      key={key}
                      disabled={!edit}
                      label={key}
                      index={value}
                      setLabelData={setLabelData}
                      labelData={labelData}
                      setError={setError}
                      error={error}
                    />
                  ))}
            {edit && (
              <Box
                display="flex"
                width="90%"
                flex={1}
                justifyContent="space-evenly"
                margin="1em auto"
                alignContent="center">
                <Select
                  id="blaStats"
                  variant="standard"
                  disableUnderline
                  required
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }}
                  value={labelData.status}
                  onChange={event =>
                    setLabelData(prev => ({
                      ...prev,
                      status: event.target.value
                    }))
                  }
                  className={classes.dropdownContainer}
                  inputProps={{
                    classes: {
                      icon: classes.icon
                    }
                  }}>
                  <MenuItem value="Qced" className={classes.dropdownText}>
                    Qced
                  </MenuItem>
                  <MenuItem value="No Document" className={classes.dropdownText}>
                    No Document
                  </MenuItem>
                  <MenuItem value="Escalate" className={classes.dropdownText}>
                    Escalate
                  </MenuItem>
                  <MenuItem value="" className={classes.dropdownText} />
                </Select>
              </Box>
            )}
          </Box>
        )
      )}

      <Dialog
        open={openSubmitConfirmation}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <div>Confirm submission</div>
            <IconButton aria-label="close" onClick={() => setOpenSubmitConfirmation(false)}>
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you have mapped the index accurately?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            color="secondary"
            className={classes.button}
            disabled={loading}
            onClick={() => {
              setOpenSubmitConfirmation(false);
              handleSwitch();
            }}>
            Cancel
          </Button>

          <Button
            startIcon={<Save />}
            variant="contained"
            onClick={handleSubmit}
            disabled={loading}
            color="secondary"
            className={classes.button}>
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};
export default PLRPage;
